import { formatInTimeZone } from "date-fns-tz";
import { DatesFormat } from "shared-types";

export const getMediaDuration = (seconds: number) => {
  const date = new Date(seconds * 1000);

  return formatInTimeZone(
    date,
    "UTC",
    seconds >= 3600
      ? DatesFormat.hourToSecondDurationFormat
      : DatesFormat.minToSecondDurationFormat
  );
};
